import { gql as gqlTag } from '@apollo/client';

/**
 * @deprecated Please use @apollo/client library for every new query/mutation
 */
export default function stringGqlTag(strings: any, ...expressions: any): string {
  return (gqlTag(strings, ...expressions) as GqlTag).loc.source.body;
}

export const gql = stringGqlTag;
